import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, withCtx as _withCtx, withModifiers as _withModifiers, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-11ac063b")

_pushScopeId("data-v-11ac063b")
const _hoisted_1 = {
  key: 0,
  class: "container popup-container",
  id: "edit-long-description"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row edit-row" }
const _hoisted_4 = { class: "editing-title" }
const _hoisted_5 = { class: "row edit-row" }
const _hoisted_6 = {
  key: 0,
  class: "editing-wrapper edit-mode position-relative"
}
const _hoisted_7 = { class: "product-text product-text-bigger-centered" }
const _hoisted_8 = {
  key: 1,
  class: "mb-2 col-md-6 mx-auto px-0"
}
const _hoisted_9 = {
  key: 2,
  class: "mx-auto mb-4 col-12 text-sm-center px-0"
}
const _hoisted_10 = { class: "description-block form-text" }
const _hoisted_11 = { class: "description-block form-text" }
const _hoisted_12 = {
  key: 3,
  class: "mx-auto col-12 text-sm-center px-0"
}
const _hoisted_13 = { class: "description-block form-text" }
const _hoisted_14 = { class: "workdays row" }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = {
  key: 0,
  class: "col-sm-8 col-md-6 px-0 mx-auto"
}
const _hoisted_17 = { class: "row content-row" }
const _hoisted_18 = {
  class: "col",
  style: {"padding-inline-end":"7px"}
}
const _hoisted_19 = { class: "slot-title" }
const _hoisted_20 = {
  class: "col",
  style: {"padding-inlne-end":"7px"}
}
const _hoisted_21 = { class: "slot-title" }
const _hoisted_22 = { class: "row content-row" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "slot-title" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "slot-title mb-0" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = {
  class: "row my-auto",
  style: {"margin-inline":"15px 5px"}
}
const _hoisted_30 = {
  class: "cbx2 my-auto",
  for: "Limited",
  tabindex: "12"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "5",
      r: "2",
      fill: "white",
      stroke: "white",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_32 = { class: "checkboxtext mx-2" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "qty-input" }
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = {
  class: "cbx2 mt-1",
  for: "Unlimited",
  tabindex: "12"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "my-auto" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "5",
      r: "2",
      fill: "white",
      stroke: "white",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_38 = { class: "checkboxtext mx-2" }
const _hoisted_39 = { class: "col-6 mx-auto" }
const _hoisted_40 = {
  key: 1,
  class: "col-sm-8 col-md-7 px-0 mx-auto"
}
const _hoisted_41 = { class: "row content-row" }
const _hoisted_42 = {
  key: 0,
  class: "col",
  style: {"padding-inline-end":"7px"}
}
const _hoisted_43 = { class: "col-5 from-to-time" }
const _hoisted_44 = {
  class: "col-5",
  style: {"padding-right":"0"}
}
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-6" }
const _hoisted_47 = { class: "col-6" }
const _hoisted_48 = {
  class: "col-2 pointer",
  style: {"padding-inline-end":"11px"}
}
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = { class: "desktop-time-slot-actions" }
const _hoisted_51 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16 ellipsis-icon" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-trash fs-16 ellipsis-icon" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-copy fs-16 ellipsis-icon" }, null, -1)
const _hoisted_54 = {
  key: 0,
  class: "row buttons-row"
}
const _hoisted_55 = { class: "col-12 buttons-content" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-11 row mx-auto" }
const _hoisted_58 = { class: "col-6" }
const _hoisted_59 = { class: "col-6" }
const _hoisted_60 = {
  class: "btn browse-button green-button add-more-slot",
  type: "button"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_62 = { class: "row col-12 mx-auto" }
const _hoisted_63 = {
  class: "description-block form-text",
  style: {"margin-top":"20px","margin-bottom":"16px"}
}
const _hoisted_64 = {
  class: "description-block form-text",
  style: {"margin-top":"0"}
}
const _hoisted_65 = {
  key: 1,
  class: "col",
  style: {"padding-inline-end":"7px"}
}
const _hoisted_66 = {
  class: "description-block form-text text-sm-center",
  style: {"margin-top":"20px","margin-bottom":"16px"}
}
const _hoisted_67 = { class: "col-6 mx-auto" }
const _hoisted_68 = {
  class: "btn w-100 browse-button green-button add-more-slot",
  type: "button"
}
const _hoisted_69 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_70 = { class: "row edit-row popup-two-buttons" }
const _hoisted_71 = { class: "col-12" }
const _hoisted_72 = {
  class: "save-button-wrapper popup-bookit-button w-100",
  type: "submit"
}
const _hoisted_73 = { class: "col-12" }
const _hoisted_74 = {
  key: 1,
  class: "container popup-container",
  id: "edit-long-description"
}
const _hoisted_75 = { class: "col-12" }
const _hoisted_76 = { class: "row edit-row" }
const _hoisted_77 = { class: "editing-wrapper p-3" }
const _hoisted_78 = { class: "watch-the-video p-0" }
const _hoisted_79 = { class: "lh18 no-opacity small-text pt-2" }
const _hoisted_80 = { class: "pointer" }
const _hoisted_81 = {
  key: 0,
  class: "mobile-time-slot-actions",
  id: "mobile-time-slot-actions"
}
const _hoisted_82 = { class: "mobile-time-slot-actions-buttons" }
const _hoisted_83 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-20 ellipsis-icon text-white" }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-trash fs-20 ellipsis-icon text-white" }, null, -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-copy fs-20 ellipsis-icon" }, null, -1)
const _hoisted_86 = { class: "actions-time-slots-back-block" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_router_link = _resolveComponent("router-link")
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode(_Transition, { name: "help" }, {
        default: _withId(() => [
          (!$setup.showHelp)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("form", {
                    onSubmit: _cache[20] || (_cache[20] = _withModifiers(($event: any) => ($setup.save($event)), ["prevent"])),
                    novalidate: ""
                  }, [
                    _createVNode("div", _hoisted_3, [
                      _createVNode("div", _hoisted_4, [
                        _createVNode("p", null, _toDisplayString(_ctx.$t('duration.editProductTime&Duration')), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_5, [
                      ($setup.foundedProductWorkingDay)
                        ? (_openBlock(), _createBlock("div", _hoisted_6, [
                            _createVNode("p", _hoisted_7, [
                              _createTextVNode(_toDisplayString(_ctx.$t('duration.productTime')) + " - " + _toDisplayString($setup.foundedProductWorkingDay.name) + " ", 1),
                              _createVNode("i", {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showHelp = !$setup.showHelp)),
                                class: "icon-f icon-question fs-20 activity-time-icon-question pointer"
                              })
                            ]),
                            ($setup.editDateMode == false)
                              ? (_openBlock(), _createBlock("p", {
                                  key: 0,
                                  class: "text-c text-action-link font-weight-bold",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.editDateMode = true))
                                }, _toDisplayString(_ctx.formatDate($setup.foundedProductWorkingDay.fromDate)) + " - " + _toDisplayString(_ctx.formatDate($setup.foundedProductWorkingDay.toDate)), 1))
                              : _createCommentVNode("", true),
                            ($setup.editDateMode == true)
                              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                                  _createVNode(_component_Calendar, {
                                    modelValue: $setup.dateRange.fromDate,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.dateRange.fromDate = $event)),
                                    selectionMode: "single",
                                    dateFormat: "dd/mm/yy",
                                    onDateSelect: $setup.priceDateChanged,
                                    ref: "calendar"
                                  }, null, 8, ["modelValue", "onDateSelect"]),
                                  _createVNode(_component_Calendar, {
                                    modelValue: $setup.dateRange.toDate,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.dateRange.toDate = $event)),
                                    selectionMode: "single",
                                    dateFormat: "dd/mm/yy",
                                    minDate: $setup.dateRange.fromDate,
                                    onHide: _cache[5] || (_cache[5] = ($event: any) => ($setup.editDateMode = false)),
                                    onDateSelect: $setup.priceDateChanged,
                                    ref: "calendar"
                                  }, null, 8, ["modelValue", "minDate", "onDateSelect"])
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.checkedDays.length == 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                                  _createVNode("small", _hoisted_10, _toDisplayString(_ctx.$t('product.defineTimeAndDuration')), 1),
                                  _createVNode("small", _hoisted_11, _toDisplayString(_ctx.$t('product.selectOnlyThoseDays')), 1)
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_12, [
                                  _createVNode("small", _hoisted_13, _toDisplayString(_ctx.$t('product.selectWeekdays')), 1)
                                ])),
                            _createVNode("div", _hoisted_14, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.weekNames, (weekname, index) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "week-day col",
                                  key: index + weekname
                                }, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    id: 'checkboxOne' + index,
                                    class: ["week-day-checkbox", { 'day-not-active': $setup.isNotActiveDay(weekname) }],
                                    value: weekname,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.checkedDays = $event)),
                                    onClick: ($event: any) => ($setup.updateTimeSlots(weekname, $event))
                                  }, null, 10, ["id", "value", "onClick"]), [
                                    [_vModelCheckbox, $setup.checkedDays]
                                  ]),
                                  _createVNode("label", {
                                    for: 'checkboxOne' + index
                                  }, _toDisplayString(_ctx.$t('weekday.' + weekname.substring(0, 2).toLowerCase())), 9, ["for"])
                                ]))
                              }), 128))
                            ]),
                            ($setup.checkedDaysForExistSlots.length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                                  ($setup.foundedProductWorkingDay && !$setup.foundedProductWorkingDay.strictHours)
                                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                                        _createVNode("div", _hoisted_17, [
                                          _createVNode("div", _hoisted_18, [
                                            _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('duration.openTime')), 1),
                                            ($setup.foundedProductTimeSlot)
                                              ? _withDirectives((_openBlock(), _createBlock("input", {
                                                  key: 0,
                                                  type: "text",
                                                  class: "form-control h-auto bookit-input product-input",
                                                  required: "",
                                                  placeholder: "09:00",
                                                  onInput: _cache[7] || (_cache[7] = ($event: any) => ($setup.validateDate('open'))),
                                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ($setup.foundedProductTimeSlot.startTime = $event))
                                                }, null, 544)), [
                                                  [_directive_maska, '##:##'],
                                                  [_vModelText, $setup.foundedProductTimeSlot.startTime]
                                                ])
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createVNode("div", _hoisted_20, [
                                            _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('duration.closeTime')), 1),
                                            ($setup.foundedProductTimeSlot)
                                              ? _withDirectives((_openBlock(), _createBlock("input", {
                                                  key: 0,
                                                  type: "text",
                                                  class: "form-control h-auto bookit-input product-input",
                                                  required: "",
                                                  placeholder: "20:00",
                                                  onInput: _cache[9] || (_cache[9] = ($event: any) => ($setup.validateDate('close'))),
                                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ($setup.foundedProductTimeSlot.endTime = $event))
                                                }, null, 544)), [
                                                  [_directive_maska, '##:##'],
                                                  [_vModelText, $setup.foundedProductTimeSlot.endTime]
                                                ])
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_22, [
                                          _createVNode("div", _hoisted_23, [
                                            _createVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('duration.duration')), 1),
                                            _withDirectives(_createVNode("input", {
                                              type: "text",
                                              placeholder: "hh:mm",
                                              onInput: _cache[11] || (_cache[11] = ($event: any) => ($setup.validateDate('duration'))),
                                              class: "form-control h-auto bookit-input product-input",
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ($setup.foundedProductTimeSlot.duration = $event)),
                                              required: ""
                                            }, null, 544), [
                                              [_directive_maska, '##:##'],
                                              [_vModelText, $setup.foundedProductTimeSlot.duration]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_25, [
                                          _createVNode("div", _hoisted_26, [
                                            _createVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('duration.isThereAQTYLimit')), 1),
                                            _createVNode("div", _hoisted_28, [
                                              _createVNode("div", _hoisted_29, [
                                                _createVNode("span", null, [
                                                  _createVNode("input", {
                                                    class: "inp-cbx2",
                                                    name: "salePerDay",
                                                    type: "radio",
                                                    style: {"display":"none"},
                                                    id: "Limited",
                                                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.foundedProductTimeSlot.quantity = 0)),
                                                    checked: $setup.foundedProductTimeSlot.quantity >= 0
                                                  }, null, 8, ["checked"]),
                                                  _createVNode("label", _hoisted_30, [
                                                    _hoisted_31,
                                                    _createVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('duration.limited')), 1)
                                                  ])
                                                ])
                                              ]),
                                              _createVNode("div", _hoisted_33, [
                                                _createVNode("span", _hoisted_34, [
                                                  _withDirectives(_createVNode("input", {
                                                    type: "number",
                                                    placeholder: "",
                                                    onFocus: _cache[14] || (_cache[14] = ($event: any) => (
                                                                    $setup.foundedProductTimeSlot.quantity =
                                                                        $setup.foundedProductTimeSlot.quantity == 0
                                                                            ? ''
                                                                            : $setup.foundedProductTimeSlot.quantity
                                                                )),
                                                    class: "form-control bookit-input product-input d-inline",
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ($setup.foundedProductTimeSlot.quantity = $event)),
                                                    min: "1",
                                                    required: "",
                                                    disabled: $setup.foundedProductTimeSlot.quantity == null
                                                  }, null, 40, ["disabled"]), [
                                                    [_vModelText, $setup.foundedProductTimeSlot.quantity]
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createVNode("div", _hoisted_35, [
                                            _createVNode("span", null, [
                                              _createVNode("input", {
                                                class: "inp-cbx2",
                                                name: "salePerDay",
                                                type: "radio",
                                                style: {"display":"none"},
                                                id: "Unlimited",
                                                onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.foundedProductTimeSlot.quantity = null)),
                                                checked: $setup.foundedProductTimeSlot.quantity == null
                                              }, null, 8, ["checked"]),
                                              _createVNode("label", _hoisted_36, [
                                                _hoisted_37,
                                                _createVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('duration.unlimited')), 1)
                                              ]),
                                              _createVNode("div", _hoisted_39, [
                                                _createVNode("button", {
                                                  class: "btn browse-button gray-button w-100",
                                                  type: "button",
                                                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($setup.saveNewParamsOfWorkingDates && $setup.saveNewParamsOfWorkingDates(...args)))
                                                }, _toDisplayString(_ctx.$t('button.more')), 1)
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  ($setup.foundedProductWorkingDay && $setup.foundedProductWorkingDay.strictHours)
                                    ? (_openBlock(), _createBlock("div", _hoisted_40, [
                                        _createVNode("div", _hoisted_41, [
                                          ($setup.slots.length > 0)
                                            ? (_openBlock(), _createBlock("div", _hoisted_42, [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.slots, (timeSlot) => {
                                                  return (_openBlock(), _createBlock("div", {
                                                    key: timeSlot.id,
                                                    class: "row work-timeline"
                                                  }, [
                                                    _createVNode("div", _hoisted_43, _toDisplayString($setup.momentFormat(timeSlot.startTime, 'time')) + " - " + _toDisplayString($setup.getEndTime(timeSlot)), 1),
                                                    _createVNode("div", _hoisted_44, [
                                                      _createVNode("div", _hoisted_45, [
                                                        _createVNode("div", _hoisted_46, _toDisplayString($setup.momentFormat(timeSlot.duration, 'time')), 1),
                                                        _createVNode("div", _hoisted_47, _toDisplayString(timeSlot.quantity), 1)
                                                      ])
                                                    ]),
                                                    _createVNode("div", _hoisted_48, [
                                                      _createVNode("div", _hoisted_49, [
                                                        _createVNode("div", _hoisted_50, [
                                                          _createVNode("div", {
                                                            onClick: ($event: any) => ($setup.copyOrEditTimeSlot(timeSlot.id, false)),
                                                            class: "action-item"
                                                          }, [
                                                            _hoisted_51
                                                          ], 8, ["onClick"]),
                                                          _createVNode("div", {
                                                            onClick: ($event: any) => ($setup.removeTimeSlot(timeSlot.id)),
                                                            class: "action-item"
                                                          }, [
                                                            _hoisted_52
                                                          ], 8, ["onClick"]),
                                                          _createVNode("div", {
                                                            onClick: ($event: any) => ($setup.copyOrEditTimeSlot(timeSlot.id, true)),
                                                            class: "action-item"
                                                          }, [
                                                            _hoisted_53
                                                          ], 8, ["onClick"])
                                                        ]),
                                                        _createVNode("i", {
                                                          onClick: ($event: any) => {$setup.showTimeSlotActions = true; $setup.choosenTimeSlotIdActions = timeSlot.id},
                                                          class: "icon-f icon-ellipsis fs-16 ellipsis-icon"
                                                        }, null, 8, ["onClick"])
                                                      ])
                                                    ])
                                                  ]))
                                                }), 128)),
                                                ($setup.checkedDays && $setup.checkedDays.length > 0)
                                                  ? (_openBlock(), _createBlock("div", _hoisted_54, [
                                                      _createVNode("div", _hoisted_55, [
                                                        _createVNode("div", _hoisted_56, [
                                                          _createVNode("div", _hoisted_57, [
                                                            _createVNode("div", _hoisted_58, [
                                                              _createVNode("button", {
                                                                class: "btn browse-button gray-button w-100",
                                                                type: "button",
                                                                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => ($setup.saveNewParamsOfWorkingDates && $setup.saveNewParamsOfWorkingDates(...args)))
                                                              }, _toDisplayString(_ctx.$t('button.more')), 1)
                                                            ]),
                                                            _createVNode("div", _hoisted_59, [
                                                              _createVNode(_component_router_link, {
                                                                to: {
                                                                            name: 'edit-product-time',
                                                                            params: {
                                                                                productId: $setup.id,
                                                                                workingDateId: $setup.foundedProductWorkingDay.id,
                                                                                selectedWeekDays: $setup.checkedDays
                                                                            }
                                                                        }
                                                              }, {
                                                                default: _withId(() => [
                                                                  _createVNode("button", _hoisted_60, [
                                                                    _hoisted_61,
                                                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('button.add')), 1)
                                                                  ])
                                                                ]),
                                                                _: 1
                                                              }, 8, ["to"])
                                                            ])
                                                          ]),
                                                          _createVNode("div", _hoisted_62, [
                                                            _createVNode("small", _hoisted_63, _toDisplayString(_ctx.$t('product.toCreateNewTimeSlot')), 1),
                                                            _createVNode("small", _hoisted_64, _toDisplayString(_ctx.$t('product.clickTheWeekday')), 1)
                                                          ])
                                                        ])
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (_openBlock(), _createBlock("div", _hoisted_65, [
                                                _createVNode("small", _hoisted_66, _toDisplayString(_ctx.$t('product.clickTheAddButton')), 1),
                                                _createVNode("div", _hoisted_67, [
                                                  _createVNode(_component_router_link, {
                                                    to: {
                                                            name: 'edit-product-time',
                                                            params: {
                                                                productId: $setup.id,
                                                                workingDateId: $setup.foundedProductWorkingDay.id,
                                                                selectedWeekDays: $setup.checkedDays
                                                            }
                                                        }
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode("button", _hoisted_68, [
                                                        _hoisted_69,
                                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('button.add')), 1)
                                                      ])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["to"])
                                                ])
                                              ]))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_70, [
                      _createVNode("div", _hoisted_71, [
                        _createVNode("button", _hoisted_72, _toDisplayString(_ctx.$t('button.save')), 1)
                      ]),
                      _createVNode("div", _hoisted_73, [
                        _createVNode("button", {
                          class: "close-button-wrapper popup-bookit-button w-100",
                          type: "button",
                          onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
                        }, _toDisplayString(_ctx.$t('button.close')), 1)
                      ])
                    ])
                  ], 32)
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_74, [
                _createVNode("div", _hoisted_75, [
                  _createVNode("div", _hoisted_76, [
                    _createVNode("div", _hoisted_77, [
                      _createVNode("div", _hoisted_78, [
                        _createVNode("a", {
                          target: "_blank",
                          href: 
                                        $setup.foundedProductWorkingDay.strictHours
                                            ? 'https://www.youtube.com/watch?v=5RbL57JhVK4'
                                            : 'https://www.youtube.com/watch?v=cdo31sez5Cg'
                                    
                        }, _toDisplayString(_ctx.$t('help.watchTheVideo')), 9, ["href"])
                      ]),
                      _createVNode("label", _hoisted_79, _toDisplayString($setup.foundedProductWorkingDay.strictHours
                                    ? _ctx.$t('help.aboutProductLimitedStrictHours')
                                    : _ctx.$t('help.aboutProductLimited')), 1),
                      _createVNode("span", null, [
                        _createVNode("div", _hoisted_80, [
                          _createVNode("i", {
                            onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.showHelp = !$setup.showHelp)),
                            class: "icon-f icon-arrow-back fs-28"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    ($setup.showTimeSlotActions)
      ? (_openBlock(), _createBlock("div", _hoisted_81, [
          _createVNode("div", _hoisted_82, [
            _createVNode("div", {
              onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.copyOrEditTimeSlot($setup.choosenTimeSlotIdActions, false))),
              class: "action-item pt-3"
            }, [
              _hoisted_83,
              _createVNode("p", null, _toDisplayString(_ctx.$t('button.edit')), 1)
            ]),
            _createVNode("div", {
              onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.removeTimeSlot($setup.choosenTimeSlotIdActions))),
              class: "action-item pt-3"
            }, [
              _hoisted_84,
              _createVNode("p", null, _toDisplayString(_ctx.$t('button.delete')), 1)
            ]),
            _createVNode("div", {
              onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.copyOrEditTimeSlot($setup.choosenTimeSlotIdActions, true))),
              class: "action-item pt-3"
            }, [
              _hoisted_85,
              _createVNode("p", null, _toDisplayString(_ctx.$t('button.copy')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_86, [
            _createVNode("button", {
              onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.showTimeSlotActions = false)),
              class: "order-modify-button-wrapper dark-circle-button",
              style: {"position":"relative"},
              type: "button"
            }, _toDisplayString(_ctx.$t('button.back')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})